import { render } from "./salesbycategory.vue?vue&type=template&id=5d5d3033&scoped=true"
import script from "./salesbycategory.vue?vue&type=script&lang=js"
export * from "./salesbycategory.vue?vue&type=script&lang=js"

import "./salesbycategory.vue?vue&type=style&index=0&id=5d5d3033&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5d3033"]])

export default __exports__